import { logout } from '../redux/slices/authSlice';
import { useBreakpoint } from '../hooks/useBreakpoint';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import * as React from 'react';
import { Box, IconButton, AppBar, Toolbar, Typography, Avatar } from '@mui/material';
import Usermenu from './UserMenu/UserMenu';
import LogoComponent from './LogoComponent';

function AppBarComponent({ user }: { user?: any }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { isMobile } = useBreakpoint();

    const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);

    const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElUser(event.currentTarget);
    };

    const logOut = () => {
        dispatch(logout());
        localStorage.clear(); // Clear all localStorage for a clean logout
        setAnchorElUser(null);
        navigate('/');
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    return (
        <>
            <AppBar
                position="fixed"
                sx={{
                    bgcolor: (theme) => theme.palette.custom.slate,
                    color: (theme) => theme.palette.text.primary,
                    boxShadow: 'none',
                    borderBottom: '1px solid',
                    borderColor: (theme) => theme.palette.divider
                }}
            >
                <Toolbar sx={{ justifyContent: 'space-between' }}>
                    <LogoComponent text="Null-e" logoSize={50}/>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        {!isMobile && <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>{user?.name}</Typography>}
                        <IconButton
                            onClick={handleOpenUserMenu}
                            sx={{ p: 0 }}
                        >
                            <Avatar alt={user?.name} src={user?.picture} sx={{ width: 35, height: 35 }} />
                        </IconButton>
                    </Box>
                </Toolbar>
            </AppBar>

            <Usermenu
                anchorElUser={anchorElUser}
                handleCloseUserMenu={handleCloseUserMenu}
                logOut={logOut}
            />
        </>
    );
}

export default AppBarComponent;